import React from 'react';
import styled from 'styled-components';
import { Paragraph } from './Paragraph';
import { HeaderWithSeparator } from './TextSubHeaders';

const VerticalCardWrapper = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 15px;
  position: relative;
  margin-bottom: 85px;
`;

const VerticalCardImage = styled.img`max-width: 100%;`;
const VerticalCardArticle = styled.article``;
const VerticalCardNumber = styled.p`
  position: absolute;
  right: 20px;
  font-size: 130px;
  line-height: 130px;
  font-family: 'Playfair Display', serif;
  color: #C49A6C;
  top: -90px;
  margin: 0;
`;

interface Props {
  header: string;
  upperSubHeader: string;
  children?: string | React.ReactNode;
  image: string;
  imageNumber?: string;
}

export const VerticalCard = ({
  header, upperSubHeader, children, image, imageNumber,
}: Props): JSX.Element => (
  <VerticalCardWrapper>
    {imageNumber && <VerticalCardNumber>{imageNumber}</VerticalCardNumber>}
    <VerticalCardImage src={image} />
    <VerticalCardArticle>
      <HeaderWithSeparator as="h2" header={header} upperSubHeader={upperSubHeader} />
      <Paragraph>
        {children}
      </Paragraph>
    </VerticalCardArticle>
  </VerticalCardWrapper>
);
